import type { IApiResponse, IResponse } from "../@types/ApiResponse";
import { EnumScreenOrientation } from "../@types/template";
import { emptySplitApi } from "./emptySliceApi";
import endpoints from "./endpoints";


export const frameApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    GetFrames: builder.query<IApiResponse<Frame.FrameList>, Frame.FrameFilter>({
      query: (filter) => {
        const params: any = {};
        
        if (filter.searchText) params.SearchText = filter.searchText;
        if (filter.name) params.Name = filter.name;
        if (filter.fromDate) params.FromDate = filter.fromDate;
        if (filter.toDate) params.ToDate = filter.toDate;
        if (filter.orientation) params.Orientation = filter.orientation;
        if (filter.page) params.Page = filter.page;
        if (filter.pageSize !== undefined) {
          if (filter.pageSize === 0) {
            // Show all - don't set pagination params
          } else {
            params.Offset = filter.pageSize;
            // params.Skip = ((filter.page || 1) - 1) * filter.pageSize;
          }
        }
        
        return {
          url: endpoints.frames,
          method: "GET",
          params: params,
        };
      },
      providesTags: ["Frame"],
    }),
    GetFrameById: builder.query<IResponse<Frame.FrameDetails>, string>({
      query: (id) => {
        return {
          url: `${endpoints.frames}/${id}`,
          method: "GET",
        };
      },
      providesTags: ["Frame"],
    }),
    CreateFrame: builder.mutation<
      IResponse<null>,
      Frame.FrameDto
    >({
      query: (formData) => {
        return {
          url: endpoints.frames,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: ["Frame"],
    }),
    UpdateFrame: builder.mutation<
      IResponse<null>,
      { id: string; data: Frame.UpdateFrameDto }
    >({
      query: ({ id, data }) => {
        return {
          url: `${endpoints.frames}/${id}`,
          method: "PUT",
          body: data,
        };
      },
      invalidatesTags: ["Frame"],
    }),
    DeleteFrame: builder.mutation<IResponse<null>, string>({
      query: (id) => {
        return {
          url: `${endpoints.frames}/${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["Frame"],
    }),
    GetFrameSummary: builder.query<IResponse<Frame.FrameSummary>, void>({
      query: () => {
        return {
          url: endpoints.framesSummary,
          method: "GET",
        };
      },
      providesTags: ["Frame"],
    }),
    GetFramesByOrientation: builder.query<IResponse<Frame.FrameList[]>, EnumScreenOrientation>({
      query: (orientation) => {
        return {
          url: `${endpoints.frames}/orientation/${orientation}`,
          method: "GET",
        };
      },
      providesTags: ["Frame"],
    }),
    GetFrameComponents: builder.query<IResponse<Frame.Component[]>, string>({
      query: (frameId) => {
        return {
          url: `${endpoints.frames}/${frameId}/components`,
          method: "GET",
        };
      },
      providesTags: ["Frame"],
    }),
    UpdateFrameComponents: builder.mutation<
      IResponse<null>,
      { frameId: string; components: Frame.Component[] }
    >({
      query: ({ frameId, components }) => {
        return {
          url: `${endpoints.frames}/${frameId}/components`,
          method: "PUT",
          body: { components },
        };
      },
      invalidatesTags: ["Frame"],
    }),
    DuplicateFrame: builder.mutation<
      IResponse<Frame.FrameDetails>,
      { id: string; newName: string }
    >({
      query: ({ id, newName }) => {
        return {
          url: `${endpoints.frames}/${id}/duplicate`,
          method: "POST",
          body: { name: newName },
        };
      },
      invalidatesTags: ["Frame"],
    }),
    GetFrameScreens: builder.query<IResponse<Frame.FrameScreen[]>, string>({
      query: (id) => {
        return {
          url: `${endpoints.frames}/screens/${id}`,
          method: "GET",
        };
      },
      providesTags: ["Frame"],
    }),
  }),
});

export const {
  useGetFramesQuery,
  useGetFrameByIdQuery,
  useCreateFrameMutation,
  useUpdateFrameMutation,
  useDeleteFrameMutation,
  useGetFrameSummaryQuery,
  useGetFrameScreensQuery,
  // useGetFramesByOrientationQuery,
  // useGetFrameComponentsQuery,
  // useUpdateFrameComponentsMutation,
  // useDuplicateFrameMutation,
} = frameApi;